import Vue from 'vue';
import timeReservation from './time-reservation/time-reservation.vue';
Vue.component('time-reservation', timeReservation);
